import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { CUSTOM_QUESTIONS_ACTION_TYPE } from '../actions';

const initialState = {};

const applyFormCustomQuestionsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case CUSTOM_QUESTIONS_ACTION_TYPE.GET_CUSTOM_QUESTIONS:
        return payload;

      case CUSTOM_QUESTIONS_ACTION_TYPE.DELETE_CUSTOM_QUESTION:
        delete draft[payload];
        break;

      case CUSTOM_QUESTIONS_ACTION_TYPE.EDIT_CUSTOM_QUESTION:
        draft[payload.customQuestionId] = {
          ...draft[payload.customQuestionId],
          ...payload,
        };
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default applyFormCustomQuestionsReducer;
